import { useClient } from "../context"

export function useStatus() {
  const client = useClient()
  return client.status
}